import io from 'socket.io-client'

let _socket

function connect () {
  _socket = io(process.env.VUE_APP_SOCKET_URL)
  _socket.on('connect', () => {})
  _socket.on('disconnect', function () { })
}

export function subscribeToCampaignsNotifications (visibilties, callback) {
  if (!_socket) {
    connect()
  }

  if (visibilties.includes('CAMPAIGN_AFTER_SALES')) {
    _socket.on('Q_NOTIFICATIONS', (data) => {
      callback(data)
    })
  }

}

export function subscribeToGenericLogs (callback) {
  if (!_socket) {
    connect()
  }
  _socket.on('Q_CMP_MONITOR', (data) => {
    callback(data)
  })
  return _socket
}

export function unsubscribeToGenericLogs () {
  if (!_socket) {
    connect()
  }
  _socket.off('Q_CMP_MONITOR', () => {
    console.log('Unsubscribed from Q_CMP_MONITOR')
  })
}
